import _regeneratorRuntime from "D:\\new-code\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CourseExam from "../../components/CourseExam.vue";
import VideoCourseChapter from "../../components/VideoCourseChapter.vue";
import CourseSoldOut from "../../components/CourseSoldOut.vue";
import Vue from "vue";
export default {
  name: "Video",
  components: {
    VideoCourseChapter: VideoCourseChapter,
    CourseSoldOut: CourseSoldOut,
    CourseExam: CourseExam
  },
  data: function data() {
    return {
      tabActive: 0,
      courseChapterTree: {
        total: {
          total_num: 0,
          study_num: 0
        },
        chapter: []
      },
      filesList: [],
      getCourseVideoInfo: {
        progress_rate: 0,
        title: "",
        grade_val: 0,
        comment_grade: 0,
        teachers: []
      },
      courseGetTest: [],
      player_container_packup: 2,
      parent: this.$route.query.parent,
      course_type: "",
      course_id: "",
      period_id: "",
      video_id: "",
      course: {},
      timer: null,
      timesTimer: null,
      currentTime: 0,
      isSoldOut: false,
      isPlay: false,
      seconds: 0,
      player: null,
      user: {}
    };
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var _this = this;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this.$nextTick(
              /*#__PURE__*/
              _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee() {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _this.$refs.videoWrap.addEventListener("contextmenu", function (event) {
                          event.preventDefault();
                        });

                        _context.next = 3;
                        return _this.init();

                      case 3:
                        _context.next = 5;
                        return _this.newDetails();

                      case 5:
                        _context.next = 7;
                        return _this.play();

                      case 7:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  computed: {
    // 是否是会员
    isShowVipFree: function isShowVipFree() {
      if (this.$store.state.token && this.course.vipData.is_vip_course == 1) {
        return true;
      }

      return false;
    }
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.$http.get("/api/app/userInfo");

            case 2:
              this.user = _context3.sent;

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    onFileClick: function onFileClick(file) {
      if (!file.ware_url) {
        return;
      }

      window.open(file.ware_url);
    },
    onPreview: function () {
      var _onPreview = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(file) {
        var data, _data;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(!this.course.is_buy && !this.isShowVipFree)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", this.$info("请您先报名"));

              case 2:
                if (!(file.file_ext == "mp3" || file.file_ext == "mp4")) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 5;
                return this.$http.get("/api/app/user/CourseWare/video/preview", {
                  video_id: file.fid
                });

              case 5:
                data = _context4.sent;
                window.open(data[0].url);
                _context4.next = 13;
                break;

              case 9:
                _context4.next = 11;
                return this.$http.get("/api/app/user/CourseWare/preview", {
                  fid: file.fid
                });

              case 11:
                _data = _context4.sent;
                window.open(_data);

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function onPreview(_x) {
        return _onPreview.apply(this, arguments);
      }

      return onPreview;
    }(),
    getChapterFile: function getChapterFile(files) {
      this.filesList = files;
      window.$(window).resize(function () {
        window.$("#periodFiles").height(window.innerHeight - 110);
        window.$("#courseGetTestBox").height(window.innerHeight - 110);
      });
      window.$("#periodFiles").height(window.innerHeight - 110);
      window.$("#courseGetTestBox").height(window.innerHeight - 110);
    },
    newDetails: function () {
      var _newDetails = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var $catalogBody, getCourseVideoInfo;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                $catalogBody = window.$("#catalog_body");
                window.$(window).resize(function () {
                  $catalogBody.height(window.innerHeight - $catalogBody.offset().top - 10);
                });
                $catalogBody.height(window.innerHeight - $catalogBody.offset().top - 10);
                _context5.next = 5;
                return this.$http.get("/api/app/course/getTest/" + this.course_id);

              case 5:
                this.courseGetTest = _context5.sent;
                _context5.next = 8;
                return this.$http.post("/api/app/courseChapterTree", {
                  id: this.course_id
                });

              case 8:
                this.courseChapterTree = _context5.sent;
                _context5.next = 11;
                return this.$http.get("/api/app/course/getCourseVideoInfo/" + this.course_id);

              case 11:
                getCourseVideoInfo = _context5.sent;
                getCourseVideoInfo.grade_val = parseInt(getCourseVideoInfo.comment_grade);
                this.getCourseVideoInfo = getCourseVideoInfo;
                this.$refs.chapter.getData();

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function newDetails() {
        return _newDetails.apply(this, arguments);
      }

      return newDetails;
    }(),
    menuUpdate: function menuUpdate(index) {
      if (index == -1) {
        this.player_container_packup = this.player_container_packup == 1 ? 2 : 1;
        return;
      }

      this.tabActive = index;
    },
    onStudentMenu: function onStudentMenu(command) {
      var that = this;
      console.log(command);

      switch (command) {
        case "center":
          that.$router.push({
            name: "MemberCalendar"
          });
          break;

        case "MemberOrder":
          that.$router.push({
            name: "MemberOrder"
          });
          break;

        case "MemberStudy":
          that.$router.push({
            name: "MemberStudy"
          });
          break;
      }
    },
    init: function () {
      var _init = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var _this2 = this;

        var data;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.clearTimer();
                this.isPlay = false;
                this.course_id = parseInt(this.$route.query.course_id);
                this.course_type = this.$route.query.course_type;
                this.period_id = this.$route.query.period_id.toString();
                this.video_id = this.$route.query.video_id;
                this.parent = this.$route.query.parent;
                _context6.next = 9;
                return this.$http.get("/api/app/courseInfo/basis_id=" + this.course_id, {}, {
                  onError: function onError(data) {
                    if (data.msg == "你来晚了，该课程已下架") {
                      _this2.isSoldOut = true;
                    }
                  }
                });

              case 9:
                data = _context6.sent;
                this.course = data.info;
                this.timesTimer = setInterval(function () {
                  if (!_this2.isPlay) {
                    return;
                  }

                  _this2.seconds++;
                }, 1000);

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }(),
    clearTimer: function clearTimer() {
      if (this.timesTimer) {
        clearInterval(this.timesTimer);
        this.timesTimer = null;
      }

      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    timerFuc: function () {
      var _timerFuc = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var current_time;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                current_time = this.seconds;
                this.seconds = 0;
                _context7.next = 4;
                return this.$http.post("/api/app/remember/video/time_new", {
                  chapter_id: this.period_id,
                  time: this.currentTime,
                  current_time: current_time
                }, {
                  showLoading: false
                });

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function timerFuc() {
        return _timerFuc.apply(this, arguments);
      }

      return timerFuc;
    }(),
    initTimer: function initTimer() {
      var _this3 = this;

      this.timer = setTimeout(
      /*#__PURE__*/
      _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _this3.timerFuc();

              case 2:
                if (_this3.isPlay) {
                  _context8.next = 4;
                  break;
                }

                return _context8.abrupt("return");

              case 4:
                _this3.initTimer();

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      })), 5000);
    },
    playNext: function () {
      var _playNext = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var period;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                period = this.$refs.chapter.getNextPeriod(this.period_id);

                if (!(!period || period.periods_type != 5 && period.periods_type != 8)) {
                  _context9.next = 3;
                  break;
                }

                return _context9.abrupt("return");

              case 3:
                _context9.next = 5;
                return this.$services.CourseService.watchVideo(period, this.course_type, this.course_id);

              case 5:
                setTimeout(function () {
                  if (Vue.config.bjy_player) {
                    Vue.config.bjy_player.play();
                  }
                }, 6000);

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function playNext() {
        return _playNext.apply(this, arguments);
      }

      return playNext;
    }(),
    play: function () {
      var _play = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        var _this4 = this;

        var course_setting, dataTime, params, data, allowControlPlay, eventTypes;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!(this.course_type != 5 && this.course_type != 8)) {
                  _context11.next = 2;
                  break;
                }

                return _context11.abrupt("return");

              case 2:
                if (!(this.video_id == "")) {
                  _context11.next = 4;
                  break;
                }

                return _context11.abrupt("return");

              case 4:
                _context11.next = 6;
                return this.$http.get("/api/app/config/course_setting");

              case 6:
                course_setting = _context11.sent.course_setting;
                _context11.next = 9;
                return this.$http.get("/api/app/video/time/" + this.period_id);

              case 9:
                dataTime = _context11.sent;
                params = {};

                if (this.parent) {
                  params.system_course_id = this.parent;
                }

                _context11.next = 14;
                return this.$http.get("/api/app/getPlayToken/chapter_id=" + this.period_id + "/course_id=" + this.course_id, params);

              case 14:
                data = _context11.sent;
                // 是否允许控制播放
                allowControlPlay = data.double_speed_play == 1;
                Vue.config.bjy_player = new window.BPlayer({
                  container: document.getElementById("video-wrap"),
                  // 设置播放器初始化的父容器
                  token: data.token,
                  memory: true,
                  //记忆播放
                  useFFplayerMSE: true,
                  //电流声改变
                  vid: data.video_id,
                  currentTime: dataTime,
                  loop: course_setting.recorded_response_event == 3,
                  enableDrag: allowControlPlay,
                  // 是否允许拖拽进度条
                  rateList: allowControlPlay ? [0.5, 0.75, 1, 1.25, 1.5, 2] : [],
                  // 倍速列表
                  user: {
                    name: this.user.nickname,
                    // 观看的学员用户名
                    number: this.user.id // 观看的学员number

                  }
                });
                eventTypes = {
                  PLAY: "play",
                  // 首次播放
                  PLAYING: "playing",
                  // 暂停后播放
                  PAUSE: "pause",
                  // 暂停
                  SEEKING: "seeking",
                  // 快进快退中
                  WAITING: "waiting",
                  // 加载中
                  SEEKED: "seeked",
                  // 快进快退结束
                  ENDED: "ended",
                  // 播放结束
                  VOLUME_CHANGE: "volume_change",
                  // 音量变化
                  RATE_CHANGE: "rate_change",
                  // 倍速变化
                  ERROR: "error",
                  // 播放出错
                  TIMEUPDATE: "timeupdate",
                  // 播放进度更新
                  LOADEDMETADATA: "loadedmetadata",
                  //
                  QUALITY_CHANGE: "quality_change",
                  // 切换清晰度
                  ENDED_AD: "ended_ad",
                  // 广告结束
                  FULLSCREEN_CHANGE: "full_screen_change" // 全屏/退出全屏

                }; // 监听首次播放事件

                Vue.config.bjy_player.on(eventTypes.PLAY, function () {
                  _this4.isPlay = true;

                  _this4.initTimer();
                });
                Vue.config.bjy_player.on(eventTypes.PLAYING, function () {
                  if (_this4.isPlay == false) {
                    _this4.isPlay = true;

                    _this4.initTimer();
                  }
                }); // 暂停

                Vue.config.bjy_player.on(eventTypes.PAUSE, function () {
                  _this4.isPlay = false;
                }); // 进度条更新

                Vue.config.bjy_player.on(eventTypes.TIMEUPDATE, function (time) {
                  _this4.currentTime = time;
                }); // 结束

                Vue.config.bjy_player.on(eventTypes.ENDED,
                /*#__PURE__*/
                _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee10() {
                  return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                      switch (_context10.prev = _context10.next) {
                        case 0:
                          _this4.isPlay = false;

                        case 1:
                        case "end":
                          return _context10.stop();
                      }
                    }
                  }, _callee10);
                })));

              case 23:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function play() {
        return _play.apply(this, arguments);
      }

      return play;
    }(),
    onPeriodTap: function onPeriodTap() {
      if (Vue.config.bjy_player && Vue.config.bjy_player.duration) {
        Vue.config.bjy_player.pause();
      }
    }
  },
  watch: {
    $route: function () {
      var _$route = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (Vue.config.bjy_player && Vue.config.bjy_player.duration) {
                  Vue.config.bjy_player.pause();
                  Vue.config.bjy_player.destroy();
                }

                _context12.next = 3;
                return this.newDetails();

              case 3:
                _context12.next = 5;
                return this.init();

              case 5:
                _context12.next = 7;
                return this.play();

              case 7:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function $route() {
        return _$route.apply(this, arguments);
      }

      return $route;
    }()
  },
  destroyed: function destroyed() {
    if (Vue.config.bjy_player && Vue.config.bjy_player.duration) {
      Vue.config.bjy_player.pause();
      Vue.config.bjy_player.destroy();
    }

    window.$("#video-wrap").html("");
    this.isPlay = false;
    this.clearTimer();
  }
};